<template>
  <div>
    <v-container fluid>
      <v-card>
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Relatórios</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-app-bar>
        <v-data-table hide-default-header :headers="headers" :items="relatorios" hide-default-footer>
          <template v-slot:item.acoes="{ item }">
            <td class="justify-center align-right layout px-0">
              <v-btn depressed small class="ml-auto my-3" color="primary" @click="item.acao"
                :loading="imprimindo && imprimindo_nome === item.nome" :disabled="item.disabled || (imprimindo && imprimindo_nome === item.nome)
                  ">{{ item.texto_botao }}</v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <as-dialogo ref="dialogoSomatorioPedidosClientes" title="Somatório de Pedidos por Cliente" max-width="800px"
      hideCloseButton hideDivider>
      <v-form ref="form" v-show="!loading">
        <v-row dense>
          <v-col cols="12">
            <v-autocomplete v-model="filtro.cliente" ref="cliente_id" :items="clientes" label="Clientes" hideDetails>
              <template v-slot:item="data" v-if="user.tipo == 'fornecedor'">
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.text"></v-list-item-title>
                  <v-list-item-subtitle v-html="data.item.cnpj"></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-form>

      <v-row v-show="loading" class="justify-center align-center mt-5">
        <v-progress-circular indeterminate size="50" width="3" color="primary"></v-progress-circular>
      </v-row>

      <div slot="botoes_esquerda">
        <v-btn depressed class="mr-4" color="primary" @click="limparFiltro" :disabled="imprimindo">Limpar</v-btn>
      </div>

      <div slot="botoes">
        <v-btn depressed class="mr-4" @click="$refs.dialogoSomatorioPedidosClientes.fechar()"
          :disabled="imprimindo">Cancelar</v-btn>
        <v-btn depressed color="primary" @click="imprimirSomatorioPedidosPorCliente" :disabled="imprimindo"
          :loading="imprimindo">Imprimir</v-btn>
      </div>
    </as-dialogo>

    <as-dialogo ref="dialogoPedidosPorClientes" title="Pedidos por Cliente" max-width="800px" hideCloseButton
      hideDivider v-if="user.tipo == 'representante' || user.tipo == 'administrador'">
      <v-form ref="form" v-show="!loading">
        <v-row dense>
          <v-col cols="6">
            <v-autocomplete v-model="filtro.cliente" ref="cliente_id" :items="clientes" label="Clientes"
              @change="carregarLojas" hideDetails />
          </v-col>
          <v-col cols="6">
            <v-autocomplete v-model="filtro.loja" ref="cliente_loja_id" :items="lojas" label="Lojas"
              :disabled="filtro.cliente == 0" :loading="carregando_lojas" hideDetails />
          </v-col>
        </v-row>
      </v-form>

      <v-row v-show="loading" class="justify-center align-center mt-5">
        <v-progress-circular indeterminate size="50" width="3" color="primary"></v-progress-circular>
      </v-row>

      <div slot="botoes_esquerda">
        <v-btn depressed class="mr-4" color="primary" @click="limparFiltro" :disabled="imprimindo">Limpar</v-btn>
      </div>
      <div slot="botoes">
        <v-btn class="mr-4" depressed @click="$refs.dialogoPedidosPorClientes.fechar()"
          :disabled="imprimindo">Cancelar</v-btn>
        <v-btn color="primary" depressed @click="imprimirPedidosPorCliente" :disabled="imprimindo"
          :loading="imprimindo">Imprimir</v-btn>
      </div>
    </as-dialogo>

    <as-dialogo ref="dialogoPedidosPorClientes" title="Pedidos por Cliente" max-width="800px" hideCloseButton
      hideDivider v-else>
      <v-form ref="form" v-show="!loading">
        <v-row dense>
          <v-col cols="12">
            <v-autocomplete v-model="filtro.cliente" ref="cliente_id" :items="clientes" label="Clientes" hideDetails>
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.text"></v-list-item-title>
                  <v-list-item-subtitle v-html="data.item.cnpj"></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-form>

      <v-row v-show="loading" class="justify-center align-center mt-5">
        <v-progress-circular indeterminate size="50" width="3" color="primary"></v-progress-circular>
      </v-row>

      <div slot="botoes_esquerda">
        <v-btn depressed class="mr-4" color="primary" @click="limparFiltro" :disabled="imprimindo">Limpar</v-btn>
      </div>
      <div slot="botoes">
        <v-btn depressed class="mr-4" @click="$refs.dialogoPedidosPorClientes.fechar()"
          :disabled="imprimindo">Cancelar</v-btn>
        <v-btn depressed color="primary" @click="imprimirPedidosPorCliente" :disabled="imprimindo"
          :loading="imprimindo">Imprimir</v-btn>
      </div>
    </as-dialogo>

    <as-dialogo ref="dialogoSomatorioPedidosRepresentantes" title="Somatório de Pedidos por Representante"
      max-width="800px" hideCloseButton hideDivider>
      <v-form ref="form" v-show="!loading">
        <v-row dense>
          <v-col cols="12">
            <v-autocomplete v-model="filtro.representante" ref="representante_id" :items="representantes"
              label="Representante" hideDetails />
          </v-col>
        </v-row>
      </v-form>
      <v-row v-show="loading" class="justify-center align-center mt-5">
        <v-progress-circular indeterminate size="50" width="3" color="primary"></v-progress-circular>
      </v-row>
      <div slot="botoes_esquerda">
        <v-btn depressed class="mr-4" color="primary" @click="limparFiltro" :disabled="imprimindo">Limpar</v-btn>
      </div>
      <div slot="botoes">
        <v-btn depressed class="mr-4" @click="$refs.dialogoSomatorioPedidosRepresentantes.fechar()"
          :disabled="imprimindo">Cancelar</v-btn>
        <v-btn depressed color="primary" @click="imprimirSomatorioPedidosPorRepresentante" :disabled="imprimindo"
          :loading="imprimindo">Imprimir</v-btn>
      </div>
    </as-dialogo>

    <as-dialogo ref="dialogoPedidosPorRepresentantes" title="Pedidos por Representante" max-width="800px"
      hideCloseButton hideDivider>
      <v-form ref="form" v-show="!loading">
        <v-row dense>
          <v-col cols="12">
            <v-autocomplete v-model="filtro.representante" ref="representante_id" :items="representantes"
              label="Representantes" hideDetails />
          </v-col>
        </v-row>
      </v-form>

      <v-row v-show="loading" class="justify-center align-center mt-5">
        <v-progress-circular indeterminate size="50" width="3" color="primary"></v-progress-circular>
      </v-row>

      <div slot="botoes_esquerda">
        <v-btn depressed class="mr-4" color="primary" @click="limparFiltro" :disabled="imprimindo">Limpar</v-btn>
      </div>

      <div slot="botoes">
        <v-btn depressed class="mr-4" @click="$refs.dialogoPedidosPorRepresentantes.fechar()"
          :disabled="imprimindo">Cancelar</v-btn>
        <v-btn depressed color="primary" @click="imprimirPedidosPorRepresentante" :disabled="imprimindo"
          :loading="imprimindo">Imprimir</v-btn>
      </div>
    </as-dialogo>

    <as-dialogo ref="dialogoSPCR" title="Somatório de Pedidos de Clientes por Representante" max-width="800px"
      hideCloseButton hideDivider>
      <v-form ref="form" v-show="!loading">
        <v-row dense>
          <v-col cols="12">
            <v-autocomplete v-model="filtro.representante" ref="representante_id" :items="representantes"
              label="Representantes" hideDetails />
          </v-col>
        </v-row>
      </v-form>

      <v-row v-show="loading" class="justify-center align-center mt-5">
        <v-progress-circular indeterminate size="50" width="3" color="primary"></v-progress-circular>
      </v-row>

      <div slot="botoes_esquerda">
        <v-btn depressed class="mr-4" color="primary" @click="limparFiltro" :disabled="imprimindo">Limpar</v-btn>
      </div>

      <div slot="botoes">
        <v-btn depressed class="mr-4" @click="$refs.dialogoSPCR.fechar()" :disabled="imprimindo">Cancelar</v-btn>
        <v-btn depressed color="primary" @click="imprimirSomatorioPedidosClientesPorRepresentante"
          :disabled="imprimindo" :loading="imprimindo">Imprimir</v-btn>
      </div>
    </as-dialogo>

    <as-dialogo ref="dialogoSomatorioPedidosFornecedores" title="Somatório de Pedidos por Fornecedor" max-width="800px"
      hideCloseButton hideDivider>
      <v-form ref="form" v-show="!loading">
        <v-row dense>
          <v-col cols="12">
            <v-autocomplete v-model="filtro.fornecedor" ref="cliente_id" :items="fornecedores" label="Clientes"
              hideDetails />
          </v-col>
        </v-row>
      </v-form>

      <v-row v-show="loading" class="justify-center align-center mt-5">
        <v-progress-circular indeterminate size="50" width="3" color="primary"></v-progress-circular>
      </v-row>

      <div slot="botoes_esquerda">
        <v-btn depressed class="mr-4" color="primary" @click="limparFiltro" :disabled="imprimindo">Limpar</v-btn>
      </div>
      <div slot="botoes">
        <v-btn depressed class="mr-4" @click="$refs.dialogoSomatorioPedidosFornecedores.fechar()"
          :disabled="imprimindo">Cancelar</v-btn>
        <v-btn depressed color="primary" @click="imprimirSomatorioPedidosPorFornecedor" :disabled="imprimindo"
          :loading="imprimindo">Imprimir</v-btn>
      </div>
    </as-dialogo>

    <as-dialogo ref="dialogoPedidosPorFornecedores" title="Pedidos por Fornecedor" max-width="800px" hideCloseButton
      hideDivider>
      <v-form ref="form" v-show="!loading">
        <v-row dense>
          <v-col cols="12">
            <v-autocomplete v-model="filtro.fornecedor" ref="cliente_id" :items="fornecedores" label="Fornecedores"
              hideDetails />
          </v-col>
        </v-row>
      </v-form>

      <v-row v-show="loading" class="justify-center align-center mt-5">
        <v-progress-circular indeterminate size="50" width="3" color="primary"></v-progress-circular>
      </v-row>

      <div slot="botoes_esquerda">
        <v-btn depressed class="mr-4" color="primary" @click="limparFiltro" :disabled="imprimindo">Limpar</v-btn>
      </div>
      <div slot="botoes">
        <v-btn depressed class="mr-4" @click="$refs.dialogoPedidosPorFornecedores.fechar()"
          :disabled="imprimindo">Cancelar</v-btn>
        <v-btn depressed color="primary" @click="imprimirPedidosPorFornecedor" :disabled="imprimindo"
          :loading="imprimindo">Imprimir</v-btn>
      </div>
    </as-dialogo>

    <as-dialogo ref="dialogoImpressaoProdutosVendidos" title="Imprimir" max-width="440px" hideCloseButton hideDivider>
      <v-label>Deseja imprimir o relatório de Produtos Vendidos?</v-label>
      <div slot="botoes">
        <v-btn depressed class="mr-4" @click="$refs.dialogoImpressaoProdutosVendidos.fechar()">Cancelar</v-btn>
        <v-btn depressed color="primary" @click="imprimirProdutosVendidos" :disabled="imprimindo"
          :loading="imprimindo">Imprimir</v-btn>
      </div>
    </as-dialogo>

    <as-dialogo ref="dialogoImpressaoProdutosConsolidado" title="Imprimir" max-width="440px" hideCloseButton
      hideDivider>
      <v-label>Deseja imprimir o relatório de Produtos Consolidado?</v-label>
      <div slot="botoes">
        <v-btn depressed class="mr-4" @click="$refs.dialogoImpressaoProdutosConsolidado.fechar()">Cancelar</v-btn>
        <v-btn depressed color="primary" @click="imprimirProdutosConsolidado" :disabled="imprimindo"
          :loading="imprimindo">Imprimir</v-btn>
      </div>
    </as-dialogo>

    <as-dialogo ref="dialogoPedidosPorClientesArquivo" title="Gerar Arquivo Único de Pedidos por Cliente"
      max-width="800px" hideCloseButton v-if="user.tipo == 'representante'" hideDivider>
      <v-form ref="form_arquivounico" v-model="form_arquivounico" v-show="!loading">
        <v-row dense>
          <v-col cols="6">
            <v-autocomplete v-model="filtro.cliente" ref="cliente_id" :items="clientes" label="Clientes"
              @change="carregarLojas" :rules="[(value) => !!value || 'Campo obrigatório']" hideDetails />
          </v-col>
          <v-col cols="6">
            <v-autocomplete v-model="filtro.loja" ref="cliente_loja_id" :items="lojas" label="Lojas"
              :disabled="filtro.cliente == 0" :loading="carregando_lojas" hideDetails />
          </v-col>
        </v-row>
      </v-form>
      <v-row v-show="loading" class="justify-center align-center mt-5">
        <v-progress-circular indeterminate size="50" width="3" color="primary"></v-progress-circular>
      </v-row>
      <div slot="botoes_esquerda">
        <v-btn depressed color="primary" @click="limparFiltro" :disabled="imprimindo">Limpar</v-btn>
      </div>
      <div slot="botoes">
        <v-btn depressed @click="$refs.dialogoPedidosPorClientesArquivo.fechar()"
          :disabled="imprimindo">Cancelar</v-btn>
        <v-btn depressed class="ml-4" color="primary" @click="imprimirPedidosPorClienteArquivo"
          :disabled="imprimindo || !form_arquivounico" :loading="imprimindo">Imprimir</v-btn>
      </div>
    </as-dialogo>

    <as-dialogo ref="dialogoLPR" title="Listagem de Participantes da Rodada" max-width="800px" hideCloseButton
      hideDivider>
      <v-form ref="form">
        <v-row dense>
          <v-col cols="12">
            <v-autocomplete v-model="tipo" :items="listagem" label="Selecione o tipo de participante" hideDetails />
          </v-col>
        </v-row>
      </v-form>

      <div slot="botoes">
        <v-btn depressed class="mr-4" @click="$refs.dialogoLPR.fechar()" :disabled="imprimindo">Cancelar</v-btn>
        <v-btn depressed color="primary" @click="abrirDialogoParticipantesRodada" :disabled="imprimindo"
          :loading="imprimindo">Imprimir</v-btn>
      </div>
    </as-dialogo>
  </div>
</template>

<script>
import ServiceRelatorios from "@/services/relatorios.js";

export default {
  name: "Relatorios",
  data() {
    return {
      loading: false,
      imprimindo: false,
      imprimindo_nome: "",
      carregando_lojas: false,
      form_arquivounico: true,
      user: {},
      headers: [
        { text: "Relatório", value: "nome", width: "90%", sortable: false },
        {
          text: "Ação",
          value: "acoes",
          align: "center",
          sortable: false,
          width: "10%",
        },
      ],
      relatorios: [],
      data_tipo: [
        {
          text: "Cadastro",
          value: "data",
        },
        {
          text: "Entrega",
          value: "entrega",
        },
      ],
      filtro: {
        cliente: 0,
        loja: 0,
        data_tipo: "data",
        data_inicial: "",
        data_final: "",
        representante: 0,
        fornecedor: 0,
      },
      clientes: [],
      lojas: [],
      rodada: {},
      representantes: [],
      fornecedores: [],
      tipo: "",
      listagem: [
        { text: "Todos", value: "", },
        { text: "Clientes", value: "clientes", },
        { text: "Representantes", value: "representantes", },
        { text: "Fornecedores", value: "fornecedores", },
      ]
    };
  },
  mounted() {
    this.rodada = JSON.parse(localStorage.getItem("rodada"));
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.user.tipo == "administrador") {
      if (this.rodada) {
        this.relatorios = [
          {
            nome: "Somatório de Pedidos por Cliente",
            texto_botao: "Imprimir",
            acao: this.abrirDialogoSomatorioPedidosClientes,
          },
          {
            nome: "Pedidos por Cliente",
            texto_botao: "Imprimir",
            acao: this.abrirDialogoPedidosPorCliente,
          },
          {
            nome: "Somatório de Pedidos por Fornecedor",
            texto_botao: "Imprimir",
            acao: this.abrirDialogoSomatorioPedidosFornecedores,
          },
          {
            nome: "Pedidos por Fornecedor",
            texto_botao: "Imprimir",
            acao: this.abrirDialogoPedidosPorFornecedor,
          },
          {
            nome: "Pedidos por Representante",
            texto_botao: "Imprimir",
            acao: this.abrirDialogoPedidosPorRepresentantes,
          },
          {
            nome: "Listagem Participantes da Rodada",
            texto_botao: "Imprimir",
            acao: this.abrirFiltroDialogoParticipantesRodada,
          },
          {
            nome: "Somatório de Pedidos de Clientes por Representante",
            texto_botao: "Imprimir",
            acao: this.abrirDialogoSomatorioPedidosClientesPorRepresentante,
          },
        ];
      } else {
        this.$eventbus.erro(
          "Você deve selecionar uma rodada para poder ver os relatórios"
        );
      }
    } else if (this.user.tipo == "representante") {
      this.relatorios = [
        {
          nome: "Somatório de Pedidos por Cliente",
          texto_botao: "Imprimir",
          acao: this.abrirDialogoSomatorioPedidosClientes,
        },
        {
          nome: "Pedidos por Cliente",
          texto_botao: "Imprimir",
          acao: this.abrirDialogoPedidosPorCliente,
        },
        {
          nome: "Somatório de Pedidos por Fornecedor",
          texto_botao: "Imprimir",
          acao: this.abrirDialogoSomatorioPedidosFornecedores,
        },
        {
          nome: "Pedidos por Fornecedor",
          texto_botao: "Imprimir",
          acao: this.abrirDialogoPedidosPorFornecedor,
        },
        {
          nome: "Arquivo Único de Pedidos por Cliente",
          texto_botao: "Imprimir",
          acao: this.abrirDialogoPedidosPorClienteArquivo,
          disabled: !this.rodada,
        },
        {
          nome: "Relatório de Remessas",
          texto_botao: "Imprimir",
          acao: () => { },
          disabled: true,
        },
      ];
    } else if (this.user.tipo == "fornecedor") {
      if (this.rodada) {
        this.relatorios = [
          {
            nome: "Somatório de Pedidos por Cliente",
            texto_botao: "Imprimir",
            acao: this.abrirDialogoSomatorioPedidosClientes,
          },
          {
            nome: "Pedidos por Cliente",
            texto_botao: "Imprimir",
            acao: this.abrirDialogoPedidosPorCliente,
          },
          {
            nome: "Somatório de Pedidos por Representante",
            texto_botao: "Imprimir",
            acao: this.abrirDialogoSomatorioPedidosRepresentantes,
          },
          {
            nome: "Pedidos por Representante",
            texto_botao: "Imprimir",
            acao: this.abrirDialogoPedidosPorRepresentantes,
          },
          {
            nome: "Produtos Vendidos",
            texto_botao: "Imprimir",
            acao: this.abrirDialogoImpressaoProdutosVendidos,
          },
          {
            nome: "Produtos Consolidado",
            texto_botao: "Imprimir",
            acao: this.abrirDialogoImpressaoProdutosConsolidado,
          },
        ];
      } else {
        this.$eventbus.erro(
          "Você deve selecionar uma rodada para poder ver os relatórios"
        );
      }
    }
  },
  methods: {
    imprimir(pdf) {
      if (this.getImpressao() == "local") {
        this.$store.commit("setPdfUrl", pdf);
      } else {
        this.$eventbus.notificar(
          "Impressão encaminhada para a Ilha de Impressão com sucesso"
        );
      }
    },
    getImpressao() {
      let impressao = JSON.parse(localStorage.getItem("impressao_remota"))
        ? "remota"
        : "local";
      return impressao;
    },
    async abrirDialogoSomatorioPedidosClientes() {
      try {
        this.loading = true;
        this.limparFiltro();
        this.$refs.dialogoSomatorioPedidosClientes.abrir();

        if (this.clientes.length == 0) {
          let clientes = await ServiceRelatorios.getClientes({
            rodada_id: this.rodada && this.rodada.id,
          });
          this.clientes = clientes.data.clientes;
          this.clientes.unshift({ value: 0, text: "Todos" });
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao carregar clientes");
      } finally {
        this.loading = false;
      }
    },
    async imprimirSomatorioPedidosPorCliente() {
      try {
        this.imprimindo = true;
        let impressao = this.getImpressao();
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        const params = {
          cliente: this.filtro.cliente,
          loja: this.filtro.loja,
          rodada_id: this.rodada && this.rodada.id,
          impressao,
        };

        if (this.$auth.user.tipo == "fornecedor" && this.filtro.cliente) {
          const found = this.clientes.find(
            (cli) => cli.id === this.filtro.cliente
          );
          params.loja = this.filtro.cliente;
          params.cliente = found.cliente_id;
        }

        let pdf = await ServiceRelatorios.imprimirSomatorioPedidosPorCliente(
          params
        );

        if (this.$auth.user.tipo == "fornecedor" && this.filtro.cliente) {
          const found = this.clientes.find(
            (cli) => cli.id === this.filtro.cliente
          );
          pdf.loja = this.filtro.cliente;
          pdf.cliente = found.cliente_id;
        }

        this.imprimir(pdf);
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao imprimir relatório");
      } finally {
        this.$refs.dialogoSomatorioPedidosClientes.fechar();
        this.imprimindo = false;
      }
    },
    async abrirDialogoPedidosPorCliente() {
      try {
        this.loading = true;
        this.limparFiltro();
        this.$refs.dialogoPedidosPorClientes.abrir();

        if (this.clientes.length == 0) {
          let clientes = await ServiceRelatorios.getClientes({
            rodada_id: this.rodada && this.rodada.id,
          });
          this.clientes = clientes.data.clientes;
          this.clientes.unshift({ value: 0, text: "Todos" });
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao carregar clientes");
      } finally {
        this.loading = false;
      }
    },
    async imprimirPedidosPorCliente() {
      try {
        this.imprimindo = true;
        let impressao = this.getImpressao();
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        const params = {
          cliente: this.filtro.cliente,
          loja: this.filtro.loja,
          rodada_id: this.rodada && this.rodada.id,
          impressao,
        };

        if (this.$auth.user.tipo == "fornecedor" && this.filtro.cliente) {
          const found = this.clientes.find(
            (cli) => cli.id === this.filtro.cliente
          );
          params.loja = this.filtro.cliente;
          params.cliente = found.cliente_id;
        }

        let pdf = await ServiceRelatorios.imprimirPedidosPorCliente(params);

        this.imprimir(pdf);
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao imprimir relatório");
      } finally {
        this.$refs.dialogoPedidosPorClientes.fechar();
        this.imprimindo = false;
      }
    },
    async abrirDialogoPedidosPorClienteArquivo() {
      try {
        this.loading = true;
        this.limparFiltro();
        this.$refs.dialogoPedidosPorClientesArquivo.abrir();

        if (this.clientes.length == 0) {
          let clientes = await ServiceRelatorios.getClientes({
            rodada_id: this.rodada && this.rodada.id,
          });
          this.clientes = clientes.data.clientes;
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao carregar clientes");
      } finally {
        this.loading = false;
      }
    },
    async imprimirPedidosPorClienteArquivo() {
      if (this.$refs.form_arquivounico.validate()) {
        try {
          this.imprimindo = true;
          let impressao = JSON.parse(localStorage.getItem("impressao_remota"))
            ? "remota"
            : "local";
          if (impressao == "local") {
            this.$store.commit("showImprimirPdf", true);
          }
          let pdf = await ServiceRelatorios.imprimirPedidosPorClienteArquivo({
            cliente: this.filtro.cliente,
            rodada_id: this.rodada && this.rodada.id,
            loja: this.filtro.loja,
            impressao,
          });

          if (pdf.data && pdf.data.msg === "Nada a imprimir") {
            this.$eventbus.notificar("Nada a imprimir");
          } else {
            this.imprimir(pdf);
          }
        } catch (error) {
          this.$eventbus.erro("Erro ao imprimir relatório");
        } finally {
          this.$refs.dialogoPedidosPorClientesArquivo.fechar();
          this.imprimindo = false;
        }
      }
    },
    async abrirDialogoSomatorioPedidosRepresentantes() {
      try {
        this.loading = true;
        this.limparFiltro();
        this.$refs.dialogoSomatorioPedidosRepresentantes.abrir();

        if (this.representantes.length == 0) {
          let representantes = await ServiceRelatorios.getRepresentantes();
          this.representantes = representantes.data.representantes;
          this.representantes.unshift({ value: 0, text: "Todos" });
        }
      } catch (error) {
        this.$eventbus.erro("Erro ao carregar representantes");
      } finally {
        this.loading = false;
      }
    },
    async imprimirSomatorioPedidosPorRepresentante() {
      try {
        this.imprimindo = true;
        let impressao = this.getImpressao();
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        let pdf = await ServiceRelatorios.imprimirSomatorioPedidosPorRepresentante(
          {
            representante: this.filtro.representante,
            rodada_id: this.rodada && this.rodada.id,
            impressao,
          }
        );
        this.imprimir(pdf);
      } catch (error) {
        this.$eventbus.erro("Erro ao imprimir relatório");
      } finally {
        this.$refs.dialogoSomatorioPedidosRepresentantes.fechar();
        this.imprimindo = false;
      }
    },
    async abrirDialogoPedidosPorRepresentantes() {
      try {
        this.loading = true;
        this.limparFiltro();
        this.$refs.dialogoPedidosPorRepresentantes.abrir();

        if (this.representantes.length == 0) {
          let representantes = await ServiceRelatorios.getRepresentantes();
          this.representantes = representantes.data.representantes;
          this.representantes.unshift({ value: 0, text: "Todos" });
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao carregar representantes");
      } finally {
        this.loading = false;
      }
    },
    async abrirDialogoSomatorioPedidosClientesPorRepresentante() {
      try {
        this.loading = true;
        this.$refs.dialogoSPCR.abrir();

        if (this.representantes.length == 0) {
          let representantes = await ServiceRelatorios.getRepresentantes();
          this.representantes = representantes.data.representantes;
          this.representantes.unshift({ value: 0, text: "Todos" });
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao carregar representantes");
      } finally {
        this.loading = false;
      }
    },
    async imprimirSomatorioPedidosClientesPorRepresentante() {
      try {
        this.imprimindo = true;
        let impressao = this.getImpressao();
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        let pdf = await ServiceRelatorios.imprimirSomatorioPedidosClientesPorRepresentante(
          {
            representante: this.filtro.representante,
            rodada_id: this.rodada && this.rodada.id,
            impressao,
          }
        );

        this.imprimir(pdf);
      } catch (error) {
        this.$eventbus.erro("Erro ao imprimir relatório");
      } finally {
        this.$refs.dialogoSPCR.fechar();
        this.imprimindo = false;
      }
    },
    async abrirFiltroDialogoParticipantesRodada() {
      this.tipo = "";
      this.$refs.dialogoLPR.abrir();
    },
    async abrirDialogoParticipantesRodada() {
      try {
        this.$refs.dialogoLPR.fechar();
        this.imprimindo = true;
        let impressao = this.getImpressao();
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        this.imprimindo_nome = "Listagem Participantes da Rodada";

        let pdf = await ServiceRelatorios.imprimirListagemParticipantesRodada({
          rodada_id: this.rodada && this.rodada.id,
          impressao,
          tipo: this.tipo,
        });

        this.imprimir(pdf);
        this.imprimindo_nome = "";
      } catch (error) {
        this.$eventbus.erro("Erro ao imprimir listagem de participantes");
      } finally {
        this.imprimindo = false;
      }
    },
    async imprimirPedidosPorRepresentante() {
      try {
        this.imprimindo = true;
        let impressao = this.getImpressao();
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        let pdf = await ServiceRelatorios.imprimirPedidosPorRepresentante({
          representante: this.filtro.representante,
          rodada_id: this.rodada && this.rodada.id,
          impressao,
        });

        this.imprimir(pdf);
      } catch (error) {
        this.$eventbus.erro("Erro ao imprimir relatório");
      } finally {
        this.$refs.dialogoPedidosPorRepresentantes.fechar();
        this.imprimindo = false;
      }
    },
    abrirDialogoImpressaoProdutosVendidos() {
      this.$refs.dialogoImpressaoProdutosVendidos.abrir();
    },
    async imprimirProdutosVendidos() {
      try {
        this.imprimindo = true;
        let impressao = this.getImpressao();
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        let pdf = await ServiceRelatorios.imprimirProdutosVendidos({
          rodada_id: this.rodada && this.rodada.id,
          impressao,
        });

        this.imprimir(pdf);
      } catch (error) {
        this.$eventbus.erro("Erro ao imprimir relatório");
      } finally {
        this.$refs.dialogoImpressaoProdutosVendidos.fechar();
        this.imprimindo = false;
      }
    },
    abrirDialogoImpressaoProdutosConsolidado() {
      this.$refs.dialogoImpressaoProdutosConsolidado.abrir();
    },
    async imprimirProdutosConsolidado() {
      try {
        this.imprimindo = true;
        let impressao = this.getImpressao();
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        let pdf = await ServiceRelatorios.imprimirProdutosConsolidado({
          rodada_id: this.rodada && this.rodada.id,
          fornecedor_id: this.user.fornecedor_id,
          impressao,
        });

        this.imprimir(pdf);
      } catch (error) {
        this.$eventbus.erro("Erro ao imprimir relatório");
      } finally {
        this.$refs.dialogoImpressaoProdutosConsolidado.fechar();
        this.imprimindo = false;
      }
    },
    async abrirDialogoSomatorioPedidosFornecedores() {
      try {
        this.loading = true;
        this.limparFiltro();
        this.$refs.dialogoSomatorioPedidosFornecedores.abrir();

        if (this.fornecedores.length == 0) {
          let fornecedores = await ServiceRelatorios.getFornecedores();
          this.fornecedores = fornecedores.data.fornecedores;
          this.fornecedores.unshift({ value: 0, text: "Todos" });
        }
      } catch (error) {
        this.$eventbus.erro("Erro ao carregar fornecedores");
      } finally {
        this.loading = false;
      }
    },
    async imprimirSomatorioPedidosPorFornecedor() {
      try {
        this.imprimindo = true;
        let impressao = this.getImpressao();
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        let pdf = await ServiceRelatorios.imprimirSomatorioPedidosPorFornecedor(
          {
            fornecedor: this.filtro.fornecedor,
            rodada_id: this.rodada && this.rodada.id,
            impressao,
          }
        );

        this.imprimir(pdf);
      } catch (error) {
        this.$eventbus.erro("Erro ao imprimir relatório");
      } finally {
        this.$refs.dialogoSomatorioPedidosFornecedores.fechar();
        this.imprimindo = false;
      }
    },
    async abrirDialogoPedidosPorFornecedor() {
      try {
        this.loading = true;
        this.limparFiltro();
        this.$refs.dialogoPedidosPorFornecedores.abrir();

        if (this.fornecedores.length == 0) {
          let fornecedores = await ServiceRelatorios.getFornecedores();
          this.fornecedores = fornecedores.data.fornecedores;
          this.fornecedores.unshift({ value: 0, text: "Todos" });
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao carregar fornecedores");
      } finally {
        this.loading = false;
      }
    },
    async imprimirPedidosPorFornecedor() {
      try {
        this.imprimindo = true;
        let impressao = this.getImpressao();
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        let pdf = await ServiceRelatorios.imprimirPedidosPorFornecedor({
          fornecedor: this.filtro.fornecedor,
          rodada_id: this.rodada && this.rodada.id,
          impressao,
        });

        this.imprimir(pdf);
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao imprimir relatório");
      } finally {
        this.$refs.dialogoPedidosPorFornecedores.fechar();
        this.imprimindo = false;
      }
    },
    async carregarLojas() {
      if (this.filtro.cliente > 0) {
        try {
          this.carregando_lojas = true;
          let lojas = await ServiceRelatorios.getLojas(this.filtro.cliente);
          this.lojas = lojas.data.lojas;
          this.lojas.unshift({ value: 0, text: "Todas" });
        } catch (error) {
          console.log(error);
          this.$eventbus.erro("Erro ao listar lojas");
        } finally {
          this.carregando_lojas = false;
        }
      } else {
        this.filtro.loja = 0;
        this.lojas = [];
      }
    },
    limparFiltro() {
      this.filtro = {
        cliente: 0,
        loja: 0,
        data_tipo: "data",
        data_inicial: "",
        data_final: "",
        representante: 0,
        fornecedor: 0,
      };
      this.lojas = [];
    },
  },
};
</script>

<style></style>
